import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var yogoRedIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 12c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12C0 5.372 5.372 0 12 0c6.627 0 12 5.372 12 12",
  fill: "#c8102e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.578 17.963a2.59 2.59 0 0 1-2.026-.99c-.551-.703-.67-1.662-.434-2.514.258-.932.818-1.689 1.268-2.555 1.46-2.507 1.401-4.381 1.401-4.381-.005-.162-.007-.322-.02-.483a4.697 4.697 0 0 0-.062-.452 3.716 3.716 0 0 0-.414-1.156 3.334 3.334 0 0 0-.731-.883 3.944 3.944 0 0 0-.644-.453 5.08 5.08 0 0 0-.757-.353 6.79 6.79 0 0 0-.857-.262 11.33 11.33 0 0 0-1.45-.244 16.062 16.062 0 0 0-1.061-.075 21.864 21.864 0 0 0-1.212-.012 20.215 20.215 0 0 0-1.087.051 14.929 14.929 0 0 0-1.018.117 8.987 8.987 0 0 0-1.373.318 6.329 6.329 0 0 0-.797.32 4.2 4.2 0 0 0-.987.662 3.467 3.467 0 0 0-.504.577 3.473 3.473 0 0 0-.495 1.09 4.785 4.785 0 0 0-.15 1.238s-.06 1.874 1.4 4.381c.45.866 1.01 1.622 1.269 2.555.235.852.117 1.811-.434 2.514a2.59 2.59 0 0 1-2.026.99c-.67 0-1.278-.26-1.737-.682a3.938 3.938 0 0 0 3.655 2.494c2.176 0 3.94-1.777 3.94-3.97 0-.781-.283-1.472-.55-2.191-.188-.509-.377-1.017-.563-1.527-.442-1.201-.865-2.434-1.06-3.704-.156-1.008-.138-2.235.624-3.008.583-.59 1.484-.722 2.291-.727.807.005 1.71.136 2.292.727.761.773.779 2 .624 3.008-.195 1.27-.619 2.503-1.06 3.704-.187.51-.375 1.018-.564 1.527-.267.719-.549 1.41-.549 2.191 0 2.192 1.764 3.97 3.94 3.97a3.94 3.94 0 0 0 3.655-2.494 2.556 2.556 0 0 1-1.737.682",
  fill: "#fff"
})));

export { yogoRedIcon as default };
//# sourceMappingURL=yogoRedIcon.js.map
